import { z } from "zod";

import { eventTypeAppCardZod } from "../eventTypeAppCardZod";

export const reminderItemSchema = z.object({
  minutes_before: z.number().positive(),
  text: z.string().optional(),
});

export const appKeysSchema = z.object({
  apiUrl: z.string().url().optional(),
  secret: z.string().optional(),
  sync_bookings_to_tasks: z.boolean().optional(),
  sync_cancellations: z.boolean().optional(),
  defaultGroupId: z.string().optional(),
  task_topic_key: z.string().optional(),
  notify_topic: z.boolean().optional(),
  notify_dm: z.boolean().optional(),
  tasks_block_calendar: z.boolean().optional(),
  reminder_minutes: z.number().optional(),
  reminders: z.array(reminderItemSchema).optional(),
  defaultMessageTemplate: z.string().optional(),
});

export const appDataSchema = eventTypeAppCardZod.extend({
  sync_bookings_to_tasks: z.boolean().optional(),
  sync_cancellations: z.boolean().optional(),
  task_topic_key: z.string().optional(),
  notify_topic: z.boolean().optional(),
  notify_dm: z.boolean().optional(),
  tasks_block_calendar: z.boolean().optional(),
  reminder_minutes: z.number().optional(),
  reminders: z.array(reminderItemSchema).optional(),
});
